import React, { Fragment, useEffect, useState } from 'react'
import { StandardPage } from '../../components/_EOS/StandardPage'
import { Stock } from '../../interfaces'
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  ListItemAvatar,
  IconButton,
  Tooltip,
  Typography
} from '@mui/material'
import { useApi } from '../../hooks/useApi'
import { ApiResponse } from '../../typings/ApiResponse'
import {
  useProductOrigins,
  useTypePosition,
  useWarehouses,
  useZones
} from '../../hooks'
import { usePagination } from '../../hooks/usePagination'
import { Status } from '../../hooks/useFetchState'
import { Filter, FilterComponent } from '../../components/_WMS/FilterComponent'
import { filterOptions, SearchBatchDetail } from './config/config'
import { useModal } from '../../hooks/useModal'
import { Modal } from '../../components/_EOS/Modal'
import { UploadOrderFile } from '../../components/Stock/UploadOrderFile/UploadOrderFile'
import { getStock, postExportStockMasive } from './config/api'
import WarningIcon from '@mui/icons-material/Warning'
import { useSnackbar } from '../../hooks/useSnackbar'
import { SnackBar } from '../../components/SnackBar/Snackbar'
import { GenericTableV2 } from '../../components/_EOS/GenericTable/GenericTableV2'
import { BatchInfo } from '../../interfaces/Stock/Stock'
import { formatExpirationDate } from '../../utils/dateHelper'
import { BatchDetailMain } from './DetailBatch/BatchDetailMain'
import { getStyleRow, mapBatchStatusToExpiredColor } from '../../utils/colors'
import { Info as InfoIcon } from '@mui/icons-material'

interface NewStockPagesProps {}

export const NewStockPages: React.FC<NewStockPagesProps> = () => {
  const { isActive, message, openSnackBar, isSuccess } = useSnackbar()
  const { callApi, state } = useApi<ApiResponse<Stock>>()
  const { callApi: callApiExportStock, state: stateExportStock } = useApi()

  const pagination = usePagination(5)
  const [selectedFilters, setSelectedFilters] = useState<Filter[]>([])
  const inventoryModal = useModal('Carga de Inventario')

  const {
    isOpen: isOpenModalExportStock,
    closeModal: CloseModalExportStock,
    openModal: openModalExportStock
  } = useModal('Exportar Stock')

  const {
    isOpen: batchDetailModalIsOpen,
    closeModal: batchDetailModalcloseModal,
    openModal: batchDetailModalOpenModal,
    extendedProps: batchDetailModalExtendenProps
  } = useModal<SearchBatchDetail>('Detalle Lotes')

  const handlePagination = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestStock(selectedFilters, auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  const handleExportStock = () => {
    callApiExportStock(postExportStockMasive(selectedFilters))
      .then(() => {
        CloseModalExportStock()
        openSnackBar(`Se agendo proceso correctamente`, true)
      })
      .catch((err) => {
        openSnackBar(`Error al agendar proceso`, true)
        console.log(err)
      })
  }

  const requestStock = (filters: Filter[], page: number, pageSize: number) => {
    callApi(getStock(filters, page, pageSize)).catch((err) => console.log(err))
  }

  const {
    typePositionsState: { typePositions },
    getTypePositions
  } = useTypePosition()

  useEffect(() => {
    if (typePositions?.length === 0) {
      getTypePositions()
    }
  }, [])

  const {
    zonesState: { zones },
    getZones
  } = useZones()

  useEffect(() => {
    if (zones?.length === 0) {
      getZones()
    }
    // se deja obtener datos al cargar fomulario
    requestStock(selectedFilters, pagination.page, pagination.pageSize)
  }, [])

  const {
    warehousesState: { warehouses },
    getWarehouses
  } = useWarehouses()

  useEffect(() => {
    if (warehouses?.length === 0) {
      getWarehouses()
    }
  }, [])

  const {
    getProductOrigins,
    productOriginsState: { productOrigins }
  } = useProductOrigins()

  useEffect(() => {
    getProductOrigins()
  }, [])

  // const headerConfig: TableHeaderConfigWithType<Stock>[] = [
  //   { field: 'url', title: 'Imagen', sortable: false, isImage: true },
  //   { field: 'positionCode', title: 'Posición', sortable: true },
  //   { field: 'stockKeepingUnit', title: 'SKU', sortable: true },
  //   { field: 'name', title: 'Producto', sortable: true },
  //   {
  //     field: 'productOriginId',
  //     title: 'Marca',
  //     sortable: true,
  //     formater: (value: unknown) =>
  //       productOrigins?.find((el) => el.productOriginId === (value as number))
  //         ?.name || ''
  //   },
  //   {
  //     field: 'warehouseId',
  //     title: 'Almacén',
  //     sortable: true,
  //     formater: (value) =>
  //       warehouses?.find((el) => el.id === value)?.warehouseName || ''
  //   },
  //   {
  //     field: 'zoneId',
  //     title: 'Zona',
  //     sortable: true,
  //     formater: (value) =>
  //       zones?.find((e) => e.zoneId === value)?.zoneName || ''
  //   },
  //   {
  //     field: 'typePositionId',
  //     title: 'Tipo De Posición',
  //     sortable: true,
  //     formater: (value) =>
  //       typePositions?.find((e) => e.typePositionId === value)
  //         ?.typePositionDescription || ''
  //   },
  //   { field: 'quantity', title: 'Cantidad', sortable: true }
  // ]

  const handleOnChangeCheckbox = (
    _changeEvent: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (checked) {
      setSelectedFilters((prev) => [
        ...prev,
        {
          key: 'considerInactivePositions',
          displayValue: 'Incluir posiciones inactivas',
          label: '',
          value: checked
        }
      ])
    } else {
      setSelectedFilters((prev) =>
        prev.filter((el) => el.key !== 'considerInactivePositions')
      )
    }
  }

  const handleOnChangeTypePositionDif = (
    _changeEvent: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (checked) {
      setSelectedFilters((prev) => [
        ...prev,
        {
          key: 'includeTypePositionDifference',
          displayValue: 'Incluir posiciones de diferencia',
          label: '',
          value: checked
        }
      ])
    } else {
      setSelectedFilters((prev) =>
        prev.filter((el) => el.key !== 'includeTypePositionDifference')
      )
    }
  }

  const handledValidateWarhouse = () => {
    const hasWarehouseId = selectedFilters.some(
      (filter) => filter.key === 'warehouseId'
    )

    const hasProductOriginId = selectedFilters.some(
      (filter) => filter.key === 'productOriginId'
    )

    if (!hasWarehouseId) {
      openSnackBar(`Seleccione filtro Almacén para Exportar`, false)
      return
    }

    if (!hasProductOriginId) {
      openSnackBar(`Seleccione filtro Marca para Exportar`, false)
      return
    }

    openModalExportStock()
  }

  const handleOpenDialogDetailBatch = (
    stockKeepingUnitId: number,
    positionId: number,
    sku: string,
    positionCode: string
  ) => {
    batchDetailModalOpenModal('sm', {
      stockKeepingUnitId,
      positionId,
      sku,
      positionCode
    })
  }

  // Wrapper para mantener el borderBottom que necesitan las filas de detalle
  const getStyleRowWithBorder = (expiredState: number) => {
    const mappedStatus = mapBatchStatusToExpiredColor(expiredState)
    return {
      ...getStyleRow(mappedStatus),
      borderBottom: '1px solid #ccc'
    }
  }

  const totalSkuQuantity = state.data?.items.find(
    (stock) => stock.totalQuantity !== '00' && stock.totalQuantity !== undefined
  )?.totalQuantity

  useEffect(() => {
    // al cambiar de filtros debe volver a pagina 0
    pagination.setPagination(0, pagination.pageSize)
    // se obtiene al tener filtros vacios (al limpiar filtros despues busca)
    if (selectedFilters.length === 0) {
      requestStock(selectedFilters, 0, pagination.pageSize)
    }
  }, [selectedFilters, pagination.pageSize])

  const maxShowFilesDetail = 2 // indica el maximo de filas para mostrar y que el boton de mueste.
  // Renderiza el detalle por cada fila. se pasa stock para obtener los ids de sku (datos fila padre)
  const renderBatchDetails = (items: BatchInfo[], stock?: Stock) => {
    const limitedItems = items?.slice(0, maxShowFilesDetail) || []

    return (
      <Fragment>
        <Grid container spacing={2}>
          {limitedItems?.map((item, index) => (
            <Grid
              item
              xs={12}
              key={index}
              style={{
                ...getStyleRowWithBorder(item.batchState)
              }}
            >
              <Grid container justifyContent='center'>
                <Grid item xs={12} sm={3}>
                  <span>
                    <strong>Lote:</strong> {item.batchNumber}
                  </span>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <span>
                    <strong>Vence:</strong>{' '}
                    {formatExpirationDate(item.expires, 'dd-MM-yyyy')}
                  </span>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <span>
                    <strong>Cantidad:</strong> {item.qty}
                  </span>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
        {items && items.length >= maxShowFilesDetail && (
          <Box mt={2} textAlign='center'>
            <Button
              variant='text'
              color='primary'
              size='small'
              onClick={() =>
                handleOpenDialogDetailBatch(
                  stock?.stockKeepingUnitId || 0,
                  stock?.positionId || 0,
                  stock?.stockKeepingUnit || '',
                  stock?.positionCode || ''
                )
              }
            >
              Más información
            </Button>
          </Box>
        )}
      </Fragment>
    )
  }

  const MyNoDetailsComponent: React.FC<{ row: any }> = () => {
    return (
      <Tooltip
        title='Producto Sin Lote / Fecha Vencimiento'
        arrow
        disableHoverListener={false} // habilita poder ver texto tooltip
      >
        <IconButton size='small'>
          <InfoIcon fontSize='small' />
        </IconButton>
      </Tooltip>
    )
  }

  // Configuración de columnas para GenericTableV2
  const columnsV2 = [
    {
      key: 'url' as keyof Stock,
      title: 'Imagen',
      width: '80px',
      render: (value: any) => (
        <Avatar
          style={{ width: 48, height: 48 }}
          variant='square'
          alt='SkuImage'
          src={value || ''}
        />
      )
    },
    { key: 'positionCode' as keyof Stock, title: 'Posición' },
    { key: 'stockKeepingUnit' as keyof Stock, title: 'SKU' },
    { key: 'name' as keyof Stock, title: 'Producto' },
    {
      key: 'productOriginId' as keyof Stock,
      title: 'Marca',
      render: (value: any) =>
        productOrigins?.find((el) => el.productOriginId === value)?.name || ''
    },
    {
      key: 'warehouseId' as keyof Stock,
      title: 'Almacén',
      render: (value: any) =>
        warehouses?.find((el) => el.id === value)?.warehouseName || ''
    },
    {
      key: 'zoneId' as keyof Stock,
      title: 'Zona',
      render: (value: any) =>
        zones?.find((e) => e.zoneId === value)?.zoneName || 'Sin Zona'
    },
    {
      key: 'typePositionId' as keyof Stock,
      title: 'Tipo De Posición',
      render: (value: any) =>
        typePositions?.find((e) => e.typePositionId === value)
          ?.typePositionDescription || ''
    },
    { key: 'quantity' as keyof Stock, title: 'Cantidad' }
  ]

  return (
    <Fragment>
      <StandardPage pageTitle={'Administrador de Stock'}>
        <div>
          <FilterComponent
            includeAddButton={true}
            includeRefreshSearch={true}
            options={filterOptions}
            onSearchClick={() =>
              requestStock(
                selectedFilters,
                pagination.page,
                pagination.pageSize
              )
            }
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={
                  selectedFilters.find(
                    (filter) => filter.key === 'considerInactivePositions'
                  )?.value || false
                }
                onChange={(e, c) => handleOnChangeCheckbox(e, c)}
                name='considerInactivePositions'
                id='considerInactivePositions'
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label='Incluir posiciones inactivas'
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  selectedFilters.find(
                    (filter) => filter.key === 'includeTypePositionDifference'
                  )?.value || false
                }
                onChange={(e, c) => handleOnChangeTypePositionDif(e, c)}
                name='includeTypePositionDifference'
                id='includeTypePositionDifference'
                inputProps={{ 'aria-label': 'primary checkbox' }}
              />
            }
            label='Incluir ubicaciones de diferencia.'
          />
        </div>

        <Box mt={2}>
          <Grid
            container
            alignItems='center'
            justifyContent='space-between'
            spacing={2}
          >
            {/* Los botones alineados a la izquierda */}
            <Grid item xs={12} sm={8}>
              <Box display='flex' justifyContent='flex-start' gap='16px'>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={() => inventoryModal.openModal('md')}
                >
                  Carga Inventario
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  onClick={handledValidateWarhouse}
                >
                  Descargar Inventario
                </Button>
              </Box>
            </Grid>

            {/* Typography alineado a la derecha */}
            {totalSkuQuantity && totalSkuQuantity !== '00' && (
              <Grid item xs={12} sm={4}>
                <Box textAlign='right'>
                  <Typography variant='subtitle1'>
                    <b>TOTAL BÚSQUEDA: {totalSkuQuantity} UNIDADES</b>
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
        {/* <GenericTableExpand<Stock>
          rowConfig={state.data?.items.map((el) =>
            getStyleRow(el?.expiredState)
          )}
          customNameExpandable='Lote/Fecha'
          customExtraColumnsCount={10}
          noDetailsComponent={MyNoDetailsComponent}
          isLoading={state.status === Status.Loading}
          headersConfig={headerConfig}
          IDKey={'stockKeepingUnit'}
          data={state.data?.items}
          pagination={{
            page: pagination.page,
            pageSize: pagination.pageSize,
            totalItem: state.data?.totalItems || 0
          }}
          onPaginationChange={handlePagination}
          expandable={{
            showExpandButton: true,
            getDetailData: (stock: Stock) => stock.details,
            renderDetail: renderBatchDetails
          }}
        /> */}
        <GenericTableV2<Stock>
          data={state.data?.items || []}
          columns={columnsV2}
          keyField='stockKeepingUnit'
          loading={state.status === Status.Loading}
          styling={{
            dense: false,
            hoverEffect: true,
            rowStyle: (row, _index) =>
              getStyleRow(mapBatchStatusToExpiredColor(row?.expiredState))
          }}
          pagination={{
            page: pagination.page,
            pageSize: pagination.pageSize,
            total: state.data?.totalItems || 0,
            onPageChange: handlePagination
          }}
          expandable={{
            getDetailData: (stock: Stock) => stock.details,
            renderContent: (details: BatchInfo[], row: Stock) =>
              renderBatchDetails(details, row),
            headerText: 'Lote',
            noDetailsComponent: MyNoDetailsComponent
          }}
        />
      </StandardPage>

      <Modal
        open={inventoryModal.isOpen}
        maxWidth={inventoryModal.size}
        title={inventoryModal.title}
        onClose={inventoryModal.closeModal}
      >
        <UploadOrderFile />
      </Modal>

      <Modal
        open={isOpenModalExportStock}
        maxWidth={'md'}
        onClose={CloseModalExportStock}
        title='¿Desea continuar con la descarga?'
        successButton={{
          action: () => handleExportStock(),
          title: 'Aceptar'
        }}
        cancelButton={{
          action: () => CloseModalExportStock(),
          title: 'Cancelar'
        }}
        loading={stateExportStock.status === Status.Loading}
      >
        <Box display='flex' alignItems='flex-start'>
          <ListItemAvatar>
            <Avatar>
              <WarningIcon />
            </Avatar>
          </ListItemAvatar>

          <Box>
            <Typography variant='body1'>
              La generación del archivo de inventario se realizará en segundo
              plano. Una vez solicitada, la descarga estará disponible en el
              menú de procesos.
            </Typography>

            <Typography
              variant='body1'
              color='textSecondary'
              style={{ marginTop: 8 }}
            >
              Si desea limitar los resultados, aplique los filtros antes de
              continuar. Este proceso puede tardar unos minutos.
            </Typography>
          </Box>
        </Box>
      </Modal>

      <SnackBar
        message={message}
        status={isSuccess ? 'success' : 'error'}
        open={isActive}
      />
      <Modal
        open={batchDetailModalIsOpen}
        maxWidth={'md'}
        title='Detalle'
        onClose={batchDetailModalcloseModal}
      >
        {batchDetailModalExtendenProps && (
          <BatchDetailMain row={batchDetailModalExtendenProps} />
        )}
      </Modal>
    </Fragment>
  )
}
